import React, {useEffect, useState} from "react";
import {withRouter} from "react-router";
import {DemandValidation} from 'constants/DemandValidation';
import {connect} from "react-redux";
import {makeStyles, Typography} from "@material-ui/core";
import VerificationProcedureType from "./components/VerificationProcedureType";
import useSearch from "hooks/useSearch";
import {useDidUpdateEffect} from "hooks/useDidUpdateEffect";
import Loading from "components/Loading";
import MoreButton from "components/button/MoreButton";
import BasicSearch from "components/BasicSearch";
import ContractorVerificationTable from "./components/ContractorVerificationTable";
import ContractorVerificationService from "services/ContractorVerificationService";
import Tr from "translations/Translations";
import DemandValidationMessages from "components/DemandValidationMessages";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    marginBottom: {
        marginBottom: theme.spacing(2),
    },
    marginBottomItalic: {
        marginBottom: theme.spacing(2),
        fontStyle: 'italic'
    }
}));

function ContractorVerification(
    {
        match,
        contractorVerificationList,
        contractorVerificationProcedure,
        demandValidation,
        demandHeader
    }) {
    const classes = useStyles();

    const FORM_ID = DemandValidation.CONTRACTOR_VERIFICATION;
    const demandId = match.params.id;
    const section = demandValidation.find(x => x.section === FORM_ID);
    const editable = section ? section.editable : false;

    const {searchData, totalCount, setTotalCount, setPaginationConfig, setSearchConfig, setSortConfig} = useSearch();
    const [working, setWorking] = useState(true);

    const isKysServiceEnabled = !!demandHeader?.applicationClientSettings?.kys?.active;

    useEffect(() => {
        ContractorVerificationService.getProcedure(demandId);
        return () => {
            ContractorVerificationService.clearResources(ContractorVerificationService.CONTRACTOR_VERIFICATION_LIST_RESOURCE_ID);
            ContractorVerificationService.clearResources(ContractorVerificationService.CONTRACTOR_VERIFICATION_PROCEDURE_RESOURCE_ID);
        }
    }, [demandId])

    useEffect(() => {
        setWorking(true);
        const {pagination, search} = searchData;
        ContractorVerificationService.getContractors(demandId, pagination, search).then(() => (setWorking(false)));
        // eslint-disable-next-line
    }, [searchData, demandId])

    useDidUpdateEffect(() => {
        if (contractorVerificationList?.totalCount !== undefined) {
            setTotalCount(contractorVerificationList.totalCount)
        }
    }, [contractorVerificationList?.totalCount]);

    const handleProcedureChange = (newProcedure) => {
        ContractorVerificationService.clearResources(ContractorVerificationService.CONTRACTOR_VERIFICATION_LIST_RESOURCE_ID);
        ContractorVerificationService.updateProcedure(demandId, newProcedure).then(() => {
            setSortConfig(null);
        })
    }

    const handleReportDownloaded = () => {
        const {pagination, search} = searchData;
        return ContractorVerificationService.getContractors(demandId, pagination, search);
    }

    if (!contractorVerificationList || !contractorVerificationProcedure) return <Loading/>;

    return (<div className={classes.root}>
        <DemandValidationMessages editable={editable} section={section}/>
        {!isKysServiceEnabled && <Typography color="primary" className={classes.marginBottomItalic}>
            {Tr('contractor.sanction.check.info')}
            <Link href={Tr('contractor.sanction.check.url')} label={'label'} target="_blank">
                LINK
            </Link>
        </Typography>}
        { !!contractorVerificationProcedure.changeable && <VerificationProcedureType
                className={classes.marginBottom}
                contractorVerificationProcedure={contractorVerificationProcedure}
                handleProcedureChange={handleProcedureChange}
                editable={editable && !contractorVerificationProcedure.readonly}
            />
        }

        <BasicSearch
            label={Tr('search_supplier')}
            searchInProgress={working}
            doSearch={setSearchConfig}
        />

        <ContractorVerificationTable
            contractorList={contractorVerificationList}
            contractorVerificationProcedure={contractorVerificationProcedure}
            working={working}
            editable={editable}
            demandId={demandId}
            onReportDownloaded={handleReportDownloaded}
        />

        <MoreButton
            config={searchData.pagination}
            setConfig={setPaginationConfig}
            totalCount={totalCount}
            loadedCount={contractorVerificationList.items.length}
            captionTrKey='showing_x_of_y_rows'
            disabled={working}
        />
    </div>)
}

export default connect((state) => ({
    contractorVerificationList: state.resources[ContractorVerificationService.CONTRACTOR_VERIFICATION_LIST_RESOURCE_ID],
    contractorVerificationProcedure: state.resources[ContractorVerificationService.CONTRACTOR_VERIFICATION_PROCEDURE_RESOURCE_ID],
    demandValidation: state.resources.demandValidation,
    demandHeader: state.resources.demandHeader,
}), {})(withRouter(ContractorVerification));

